var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.prospectStage &&
    _vm.prospectStage.id &&
    _vm.prospectStage.instructions
    ? _c(
        "div",
        {
          staticClass: "overflow-y-auto",
          style: { height: "calc(100vh - 4.5rem - 8rem - 3.5rem)" }
        },
        [
          !_vm.prospectStage.instructions.length
            ? _c(
                "div",
                { staticClass: "h-full grid items-center justify-center" },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "There are no instructions for this stage." }
                  })
                ],
                1
              )
            : _vm.prospectStage.instructions.length
            ? _c(
                "div",
                { staticClass: "py-5 px-6 flex flex-col gap-2" },
                _vm._l(_vm.prospectStage.instructions, function(instruction) {
                  return _c("InstructionProspect", {
                    key: instruction.id,
                    attrs: { instruction: instruction, editable: "" }
                  })
                }),
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-302e186b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302e186b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/prospectPanel/StageInstructionTab.vue
// module id = null
// module chunks = 